// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
**Author: Santosh Kumar Dash
**Author URL: http://santoshdash.epizy.com/
**Github URL: https://github.com/quintuslabs/dashio-admin
*/

.main-content-container.p-4.container-fluid {
    display: flex;
    flex-direction: column;
}

.right-panel {
    padding: 1.875em;
}
.card {
    margin-bottom: 1.875em;
    border-radius: 5px !important;
    padding: 0;
    box-shadow: 0 0 20px rgba(0,0,0,.08) ;
    border: none !important;
}

.card .card-body {
    float: left;
    padding: 1.25em;
    position: relative;
    width: 100%;
}

.stat-widget-five {
    min-height: 60px;
}
.stat-widget-five .stat-icon {
    font-size: 50px;
    line-height: 50px;
    position: absolute;
    left: 30px;
    top: 20px;
}
.stat-widget-five .stat-content {
    margin-left: 100px;
}

.dib {
    float: right;
    margin-right: 2vw;
}
.flat-color-1 {
    color: #00c292;
}
.flat-color-2 {
    color: #ab8ce4;
}
.stat-widget-five .stat-text {
    color: #455a64;
    font-size: 20px;
}
.stat-widget-five .stat-heading {
    color: #99abb4;
    font-size: 14px;
}

.flat-color-3 {
    color: #03a9f3;
}
.flat-color-4 {
    color: #fb9678;
}


.table {
    width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
}
table {
    border-collapse: collapse;
}
.order-table {
    position: relative;
}
.ov-h {
    overflow: hidden;
}


.order-table:after, .order-table:before {
    content: "";
    position: absolute;
    top: 0;
    height: 37px;
    width: 10px;
    background: #e8e9ef;
}



.order-table tr th {
    background: #e8e9ef;
}
.table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
}
.table td, .table th {
    padding: .75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
}

.table-stats table td {
    color: #343a40;
    font-size: 14px;
    font-weight: 600;
    text-transform: capitalize;
    vertical-align: middle;
}
.table-stats table {
    font-family: open sans,sans-serif;
}

.order-table .badge-complete {
    background: #00c292;
}
.order-table .badge {
    color: #fff;
    padding: 10px;
    text-transform: uppercase;
    font-weight: 400;
}
.badge {
    display: inline-block;
    padding: .25em .4em;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: .25rem;
}

.order-table .badge-pending {
    background: #fb9678;
}

a.canvasjs-chart-credit {
    visibility: hidden;
}

.tdl-holder {
    margin: 0 auto;
}

.tdl-holder ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.tdl-holder li {
    position: relative;
    background-color: transparent;
    list-style: outside none none;
    margin: 0;
    padding: 7px 0;
}

.tdl-holder li:after, .tdl-holder li:before {
    content: "\\f142";
    top: 24px;
    position: absolute;
    font: normal normal normal 14px/1 FontAwesome;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    z-index: 99;
    color: #99abb4;
}

.tdl-holder label {
    cursor: pointer;
    display: block;
    line-height: 50px;
    padding: 0 15px;
    padding-left: 30px;
    position: relative;
    margin: 0!important;
    background: #fafafa;
    color: #99abb4;
    font-size: 15px;
    transition: all .2s linear;
}

.tdl-holder li:after {
    left: 10px;
}


.tdl-holder li span {
    margin-left: 30px;
    vertical-align: middle;
    transition: all .2s linear;
}

.tdl-holder label a {
    border-radius: 50%;
    color: rgba(153,171,180,.5);
    float: right;
    line-height: normal;
    margin-top: 15px;
    text-align: center;
    text-decoration: none;
    height: 16px;
    width: 20px;
    transition: all .2s linear;
}

.fa-remove:before, .fa-close:before, .fa-times:before {
    content: "\\f00d";
}



.tdl-holder input[type=checkbox]:checked~span {
    text-decoration: line-through;
}

.messenger-box {
    padding-top: 15px;
}

.messenger-box ul {
    padding-left: 0;
    display: inline-block;
    width: 100%;
    padding-bottom: 15px;
}

.messenger-box li {
    list-style: none;
    padding-bottom: 20px;
}

.messenger-box .avatar {
    width: 64px;
    float: left;
}

.messenger-box .msg-box {
    margin-left: 84px;
}

.messenger-box .inner-box {
    position: relative;
    border-radius: 10px;
    background-color: #f1f2f7;
    font-size: 14px;
    color: #9aa0a4;
    padding: 14px 20px;
    display: table;
}

.messenger-box .inner-box .name {
    font-size: 16px;
    padding-bottom: 10px;
}

.messenger-box .inner-box:after {
    content: "";
    position: absolute;
    top: 10px;
    left: -18px;
    width: 18px;
    height: 18px;
    border-style: solid;
    border-width: 9px;
    border-color: transparent #f1f2f7 transparent transparent;
}

.messenger-box .avatar .send-time {
    font-size: 11px;
    text-align: center;
    padding-top: 5px;
}

.messenger-box .msg-sent .avatar, .messenger-box .msg-sent .msg-box {
    float: right;
}
.messenger-box .avatar {
    width: 64px;
    float: left;
}
.messenger-box .msg-sent .inner-box:after {
    left: inherit;
    right: -18px;
    border-color: transparent transparent transparent #f1f2f7;
}

.messenger-box .send-mgs {
    margin-top: 20px;
    margin-bottom: 9px;
    position: relative;
}

.messenger-box .send-mgs .yourmsg {
    margin-right: 55px;
}

.messenger-box .send-mgs .yourmsg input {
    border: 1px solid #eceff1;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 7px;
}

.messenger-box .send-mgs .msg-send-btn {
    background: #03a9f3;
    color: #fff;
    font-size: 28px;
    border-radius: 7px;
    padding: 0;
    text-align: center;
    height: 40px;
    width: 40px;
    position: absolute;
    right: 0;
    top: 0;
}

 li.menu-item-has-children a:hover:before {
    border-color: #03a9f3 #03a9f3 transparent transparent;
}


/* width */
#sidebar::-webkit-scrollbar {
    width: 3px;
  }
  
  /* Track */
  #sidebar::-webkit-scrollbar-track {
    box-shadow: inset 0 0 2px grey;
    border-radius: 10px;
  }
  
  /* Handle */
  #sidebar::-webkit-scrollbar-thumb {
    background: #007bff4b;
    border-radius: 2px;
  }`, "",{"version":3,"sources":["webpack://./src/static/css/CardStyling.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,UAAU;IAEV,qCAAqC;IACrC,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;;AAGA;IACI,WAAW;IACX,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;;;AAGA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;;;AAIA;IACI,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,gCAAgC;AACpC;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;AAC1B;AACA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,6BAA6B;IAC7B,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,6CAA6C;IAC7C,mCAAmC;IACnC,kCAAkC;IAClC,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IAEf,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,iBAAiB;IACjB,sBAAsB;IAEtB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,WAAW;IAEX,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;;;AAIA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,yDAAyD;AAC7D;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,aAAa;IACb,YAAY;IACZ,yDAAyD;AAC7D;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;CAEC;IACG,qDAAqD;AACzD;;;AAGA,UAAU;AACV;IACI,UAAU;EACZ;;EAEA,UAAU;EACV;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA,WAAW;EACX;IACE,qBAAqB;IACrB,kBAAkB;EACpB","sourcesContent":["/*\n**Author: Santosh Kumar Dash\n**Author URL: http://santoshdash.epizy.com/\n**Github URL: https://github.com/quintuslabs/dashio-admin\n*/\n\n.main-content-container.p-4.container-fluid {\n    display: flex;\n    flex-direction: column;\n}\n\n.right-panel {\n    padding: 1.875em;\n}\n.card {\n    margin-bottom: 1.875em;\n    border-radius: 5px !important;\n    padding: 0;\n    -webkit-box-shadow: 0 0 20px rgba(0,0,0,.08);\n    box-shadow: 0 0 20px rgba(0,0,0,.08) ;\n    border: none !important;\n}\n\n.card .card-body {\n    float: left;\n    padding: 1.25em;\n    position: relative;\n    width: 100%;\n}\n\n.stat-widget-five {\n    min-height: 60px;\n}\n.stat-widget-five .stat-icon {\n    font-size: 50px;\n    line-height: 50px;\n    position: absolute;\n    left: 30px;\n    top: 20px;\n}\n.stat-widget-five .stat-content {\n    margin-left: 100px;\n}\n\n.dib {\n    float: right;\n    margin-right: 2vw;\n}\n.flat-color-1 {\n    color: #00c292;\n}\n.flat-color-2 {\n    color: #ab8ce4;\n}\n.stat-widget-five .stat-text {\n    color: #455a64;\n    font-size: 20px;\n}\n.stat-widget-five .stat-heading {\n    color: #99abb4;\n    font-size: 14px;\n}\n\n.flat-color-3 {\n    color: #03a9f3;\n}\n.flat-color-4 {\n    color: #fb9678;\n}\n\n\n.table {\n    width: 100%;\n    margin-bottom: 1rem;\n    background-color: transparent;\n}\ntable {\n    border-collapse: collapse;\n}\n.order-table {\n    position: relative;\n}\n.ov-h {\n    overflow: hidden;\n}\n\n\n.order-table:after, .order-table:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    height: 37px;\n    width: 10px;\n    background: #e8e9ef;\n}\n\n\n\n.order-table tr th {\n    background: #e8e9ef;\n}\n.table thead th {\n    vertical-align: bottom;\n    border-bottom: 2px solid #dee2e6;\n}\n.table td, .table th {\n    padding: .75rem;\n    vertical-align: top;\n    border-top: 1px solid #dee2e6;\n}\n\n.table-stats table td {\n    color: #343a40;\n    font-size: 14px;\n    font-weight: 600;\n    text-transform: capitalize;\n    vertical-align: middle;\n}\n.table-stats table {\n    font-family: open sans,sans-serif;\n}\n\n.order-table .badge-complete {\n    background: #00c292;\n}\n.order-table .badge {\n    color: #fff;\n    padding: 10px;\n    text-transform: uppercase;\n    font-weight: 400;\n}\n.badge {\n    display: inline-block;\n    padding: .25em .4em;\n    font-size: 75%;\n    font-weight: 700;\n    line-height: 1;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: baseline;\n    border-radius: .25rem;\n}\n\n.order-table .badge-pending {\n    background: #fb9678;\n}\n\na.canvasjs-chart-credit {\n    visibility: hidden;\n}\n\n.tdl-holder {\n    margin: 0 auto;\n}\n\n.tdl-holder ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.tdl-holder li {\n    position: relative;\n    background-color: transparent;\n    list-style: outside none none;\n    margin: 0;\n    padding: 7px 0;\n}\n\n.tdl-holder li:after, .tdl-holder li:before {\n    content: \"\\f142\";\n    top: 24px;\n    position: absolute;\n    font: normal normal normal 14px/1 FontAwesome;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    z-index: 99;\n    color: #99abb4;\n}\n\n.tdl-holder label {\n    cursor: pointer;\n    display: block;\n    line-height: 50px;\n    padding: 0 15px;\n    padding-left: 30px;\n    position: relative;\n    margin: 0!important;\n    background: #fafafa;\n    color: #99abb4;\n    font-size: 15px;\n    -webkit-transition: all .2s linear;\n    transition: all .2s linear;\n}\n\n.tdl-holder li:after {\n    left: 10px;\n}\n\n\n.tdl-holder li span {\n    margin-left: 30px;\n    vertical-align: middle;\n    -webkit-transition: all .2s linear;\n    transition: all .2s linear;\n}\n\n.tdl-holder label a {\n    border-radius: 50%;\n    color: rgba(153,171,180,.5);\n    float: right;\n    line-height: normal;\n    margin-top: 15px;\n    text-align: center;\n    text-decoration: none;\n    height: 16px;\n    width: 20px;\n    -webkit-transition: all .2s linear;\n    transition: all .2s linear;\n}\n\n.fa-remove:before, .fa-close:before, .fa-times:before {\n    content: \"\\f00d\";\n}\n\n\n\n.tdl-holder input[type=checkbox]:checked~span {\n    text-decoration: line-through;\n}\n\n.messenger-box {\n    padding-top: 15px;\n}\n\n.messenger-box ul {\n    padding-left: 0;\n    display: inline-block;\n    width: 100%;\n    padding-bottom: 15px;\n}\n\n.messenger-box li {\n    list-style: none;\n    padding-bottom: 20px;\n}\n\n.messenger-box .avatar {\n    width: 64px;\n    float: left;\n}\n\n.messenger-box .msg-box {\n    margin-left: 84px;\n}\n\n.messenger-box .inner-box {\n    position: relative;\n    border-radius: 10px;\n    background-color: #f1f2f7;\n    font-size: 14px;\n    color: #9aa0a4;\n    padding: 14px 20px;\n    display: table;\n}\n\n.messenger-box .inner-box .name {\n    font-size: 16px;\n    padding-bottom: 10px;\n}\n\n.messenger-box .inner-box:after {\n    content: \"\";\n    position: absolute;\n    top: 10px;\n    left: -18px;\n    width: 18px;\n    height: 18px;\n    border-style: solid;\n    border-width: 9px;\n    border-color: transparent #f1f2f7 transparent transparent;\n}\n\n.messenger-box .avatar .send-time {\n    font-size: 11px;\n    text-align: center;\n    padding-top: 5px;\n}\n\n.messenger-box .msg-sent .avatar, .messenger-box .msg-sent .msg-box {\n    float: right;\n}\n.messenger-box .avatar {\n    width: 64px;\n    float: left;\n}\n.messenger-box .msg-sent .inner-box:after {\n    left: inherit;\n    right: -18px;\n    border-color: transparent transparent transparent #f1f2f7;\n}\n\n.messenger-box .send-mgs {\n    margin-top: 20px;\n    margin-bottom: 9px;\n    position: relative;\n}\n\n.messenger-box .send-mgs .yourmsg {\n    margin-right: 55px;\n}\n\n.messenger-box .send-mgs .yourmsg input {\n    border: 1px solid #eceff1;\n    height: 40px;\n    line-height: 40px;\n    font-size: 14px;\n    border-radius: 7px;\n}\n\n.messenger-box .send-mgs .msg-send-btn {\n    background: #03a9f3;\n    color: #fff;\n    font-size: 28px;\n    border-radius: 7px;\n    padding: 0;\n    text-align: center;\n    height: 40px;\n    width: 40px;\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n li.menu-item-has-children a:hover:before {\n    border-color: #03a9f3 #03a9f3 transparent transparent;\n}\n\n\n/* width */\n#sidebar::-webkit-scrollbar {\n    width: 3px;\n  }\n  \n  /* Track */\n  #sidebar::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 2px grey;\n    border-radius: 10px;\n  }\n  \n  /* Handle */\n  #sidebar::-webkit-scrollbar-thumb {\n    background: #007bff4b;\n    border-radius: 2px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
